<template>
  <div
    class="timeline-container d-flex justify-content-around align-items-start position-relative"
  >
    <div
      v-for="(step, index) in steps"
      :key="index"
      class="timeline-step text-center"
      :class="{
        completed: step.status === 'completed',
        active: step.status === 'in-progress',
        rejected: step.status === 'rejected',
      }"
    >
      <div class="circle">
        <template v-if="step.status === 'completed'">
          <span class="svg-icon svg-icon-white">
            <inline-svg
              class="mt-1"
              src="/media/svg/soha/icons/check-1.svg"
            />
          </span>
        </template>
        <template v-else-if="step.status === 'rejected'">
          <span class="svg-icon svg-icon-white">
            <inline-svg
              class="mt-1"
              src="/media/svg/soha/icons/times.svg"
            />
          </span>
        </template>
        <template v-else>
          <span class="mt-1">{{ toPersianDigits(index + 1) }}</span>
        </template>
      </div>
      <div class="step-label mt-2">
        {{ step.name }}
      </div>
    </div>

    <!-- خط بین دایره‌ها -->
    <!-- <div class="timeline-line"></div> -->
    <!-- <div class="timeline-line-progress" :style="{ width: progressWidth }"></div> -->
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";

export default {
  mixins: [UIMixin],

  props: {
    steps: null,
    currentStep: null,
  },
  computed: {
    progressWidth() {
      const percent = ((this.currentStep - 1) / (this.steps.length - 1)) * 100;
      return this.currentStep > 1 ? `${percent}%` : "0%";
    },
  },
};
</script>

<style scoped>
.timeline-container {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  padding-bottom: 1rem;
  gap: 1rem;
  scrollbar-width: thin; /* برای فایرفاکس */
  -webkit-overflow-scrolling: touch; /* روان بودن اسکرول در موبایل */
}

.timeline-step {
  flex: 0 0 auto; /* جلوگیری از کوچک شدن */
  min-width: 8rem; /* یا هر عرضی که مناسب باشه */
  text-align: center;
  max-width: 20rem;
}

.circle {
  width: 2rem;
  height: 2rem;
  background-color: white;
  border: 0.3rem solid var(--box-border-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  margin: 0 auto;
  box-shadow: 0 0 0 0.3rem #fff;
  transition: all 0.3s ease;
  color: var(--muted-color);
}
.timeline-step.completed .circle {
  background-color: var(--third-color);
  color: white;
  border: none;
}
.timeline-step.rejected .circle {
  background-color: var(--danger-color);
  color: white;
  border: none;
}
.timeline-step.active .circle {
  border: 0.3rem solid var(--secondary-color);
  color: var(--secondary-color);
}
.timeline-step.active .step-label {
  color: var(--secondary-color);
  font-weight: bold;
}
.timeline-step.completed .step-label {
  color: var(--third-color);
}

.timeline-step.rejected .step-label {
  color: var(--danger-color);
}
.timeline-line {
  position: absolute;
  top: 22%;
  left: 0;
  right: 0;
  height: 0.3rem;
  background-color: var(--box-border-color);
  z-index: 1;
}
.timeline-line-progress {
  position: absolute;
  top: 24px;
  left: 0;
  height: 0.3rem;
  background-color: var(--third-color);
  z-index: 1;
  transition: width 0.4s ease;
}
.step-label {
  font-size: 1.1rem;
  color: var(--muted-color);
  margin-top: 8px;
  white-space: normal
}
.timeline-container::-webkit-scrollbar {
  height: 6px;
}

.timeline-container::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 3px;
}
@media (max-width: 767px) {
  .timeline-container {
    flex-direction: column !important;
    align-items: flex-start;
    overflow-x: hidden;
  }

  .timeline-step {
    flex: none;
    width: 100%;
    display: flex;
    align-items: center;
    margin: 0 2rem 2.5rem 0;
    max-width: 100%;
  }

  .circle {
    margin: 0 0 0 1.2rem;
    width: 2.5rem;
    height: 2.5rem;
  }

  .step-label {
    margin-top: 0;
    font-size: 1.5rem;
    text-align: right;
    white-space: normal !important;
  }

  .timeline-line-progress {
    top: 0;
    left: 2rem;
    width: 0.3rem !important;
    height: 100%;
  }

  .timeline-line {
    display: none;
  }

  .timeline-line-progress {
    background-color: var(--third-color);
    height: calc(
      100% * ((var(--step-progress, 1) - 1) / (var(--step-total, 4) - 1))
    );
    transition: height 0.4s ease;
    width: 0.3rem;
  }
}
</style>
